module.exports = __webpack_public_path__ + "static/Sonyax5c-76800ef31338adff7369377258b515b6.png";